import { render, staticRenderFns } from "./lafia_castle.vue?vue&type=template&id=7c72f1ba&scoped=true"
import script from "./lafia_castle.vue?vue&type=script&lang=js"
export * from "./lafia_castle.vue?vue&type=script&lang=js"
import style0 from "./lafia_castle.vue?vue&type=style&index=0&id=7c72f1ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../makeup-web/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c72f1ba",
  null
  
)

export default component.exports